export function assertUnreachable(value: never, errorMessage = 'Unhandled') {
  console.error(errorMessage, ' ', value);
}
